import {CountByCategoriesDTO} from 'src/services/api/endpoints/ReportsEndpoint'

export const convertDateToDayOfWeek = (dates: Array<number>) => {
  let dictionary: {[x: number]: string} = {
    0: 'Dom',
    1: 'Seg',
    2: 'Ter',
    3: 'Qua',
    4: 'Qui',
    5: 'Sex',
    6: 'Sab',
  }

  return dates.map((it) => dictionary[it])
}

export const formatChartCountSeriesAndTranslateNames = (data: CountByCategoriesDTO, categorizeBy: string) => {
  let translateSeries: any = {series: [], categories: []}

  data.series.forEach((it) => {
    if (it.name === 'female') translateSeries.series.push({name: 'Mulheres', data: it.data})
    else if (it.name === 'male') {
      translateSeries.series.push({name: 'Homens', data: it.data})

      if (categorizeBy === 'date') {
        let dateToConvert = data.categories.map((item) => new Date(item).getUTCDay())
        translateSeries.categories = convertDateToDayOfWeek(dateToConvert)
      } else if (categorizeBy === 'hour') translateSeries.categories = data.categories.map((it) => it + 'h')
    } else if (it.name === 'unidentified') translateSeries.series.push({name: 'Não identificado', data: it.data})
  })

  return translateSeries
}

export const calculatePercent = (items?: number, total?: number) => {
  if (!items || !total) return 0
  return (items / total) * 100
}

export const countPeople = (persons: {[age: string]: number}) => {
  let count = 0

  for (let age = 0; age <= 100; age++) {
    const ageStr = age.toString()
    count += persons[ageStr] || 0
  }

  return count
}

export const AGE_GROUPS = ['Criança', 'Jovem', 'Adulto', 'Idoso']

const CHILDREN_AGE_RANGE = ['0-15']
const YOUNG_AGE_RANGE = ['16-20', '21-25']
const ADULT_AGE_RANGE = ['26-30', '31-35', '36-40', '41-45', '46-50', '51-55', '56-60']

export const getAgeGroup = (
  categories?: string[],
  serie?: {
    name: string
    group: string
    data: number[]
  },
) => {
  const ageGroup = [0, 0, 0, 0]
  if (!categories || !serie) return ageGroup

  for (const category of categories) {
    const index = categories.indexOf(category)
    if (CHILDREN_AGE_RANGE.includes(category)) {
      ageGroup[0] += serie.data[index]
    } else if (YOUNG_AGE_RANGE.includes(category)) {
      ageGroup[1] += serie.data[index]
    } else if (ADULT_AGE_RANGE.includes(category)) {
      ageGroup[2] += serie.data[index]
    } else {
      ageGroup[3] += serie.data[index]
    }
  }

  return ageGroup
}

export const getNumericAgeGroup = (persons: {[age: string]: number}) => {
  const ageGroup = [0, 0, 0, 0, 0, 0, 0, 0, 0]

  for (let age = 0; age <= 100; age++) {
    const ageStr = age.toString()
    const count = persons[ageStr] || 0

    if (age <= 14) ageGroup[0] += count
    else if (age <= 20) ageGroup[1] += count
    else if (age <= 25) ageGroup[2] += count
    else if (age <= 30) ageGroup[3] += count
    else if (age <= 35) ageGroup[4] += count
    else if (age <= 40) ageGroup[5] += count
    else if (age <= 45) ageGroup[6] += count
    else if (age <= 50) ageGroup[7] += count
    else ageGroup[8] += count
  }

  return ageGroup
}

export enum GenderEnum {
  MALE = 'Male',
  WOMAN = 'Female',
  UNDETERMINED = 'Undetermined',
}

enum FaceDetectionEnum {
  ALLOWED = 'Permitidas',
  NOT_ALLOWED = 'Não permitidas',
}

export function getFaceDetectionColor(faceDetection: string) {
  switch (faceDetection) {
    case FaceDetectionEnum.ALLOWED:
      return '#5CAA6E'
    case FaceDetectionEnum.NOT_ALLOWED:
      return '#D75C5C'
    default:
      return '#F5B971'
  }
}

export function getColorByGender(gender: string) {
  switch (gender) {
    case GenderEnum.MALE:
      return '#4A89DC'
    case GenderEnum.WOMAN:
      return '#B079E6'
    default:
      return '#F5B971'
  }
}

export function translateGender(gender: string) {
  switch (gender) {
    case GenderEnum.MALE:
      return 'Homem'
    case GenderEnum.WOMAN:
      return 'Mulher'
    default:
      return 'Indefinido'
  }
}

const objectTranslated: {[key: string]: string} = {
  car: 'carro',
  crowd: 'aglomeração',
  person: 'pessoa',
  plate: 'placa',
  'safety-clothes': 'Equipamento de Segurança Incompleto',
  'without-safety-clothes': 'Equipamento de Segurança Incompleto',
  'cell phone': 'Celulares',
  'cell-phone': 'Celulares',
  body: 'Corpos',
  face: 'Faces',
  fork: 'Garfos',
  knife: 'Facas',
  celllabel: 'Celulares',
  scissors: 'Tesouras',
  bottle: 'Garrafas',
  cup: 'Copos',
  spoon: 'Colheres',
  book: 'Livros',
  clock: 'Relógios',
  mouse: 'Mouses',
  motorbike: 'Motos',
  bicycle: 'Bicicletas',
  motorcycle: 'Motocicletas',
  airplane: 'Aviões',
  bus: 'Ônibus',
  train: 'Trens',
  truck: 'Caminhões',
  boat: 'Barcos',
  trafficlabel: 'Semáforos',
  fire: 'Hidrantes',
  'stop sign': 'Sinais de Parada',
  bench: 'Bancos de Sentar',
  bird: 'Pássaros',
  cat: 'Gatos',
  dog: 'Cães',
  horse: 'Cavalos',
  sheep: 'Ovelhas',
  cow: 'Vacas',
  backpack: 'Mochilas',
  umbrella: 'Guardas-Chuva',
  handbag: 'Bolsas',
  suitcase: 'Malas de Viagem',
  'baseball bat': 'Tacos de Beisebol',
  'tennis racket': 'Raquetes de Tênis',
  chair: 'Cadeiras',
  'potted plant': 'Vasos de Planta',
  tv: 'Televisões',
  laptop: 'Computadores Portáteis',
  keyboard: 'Teclados',
  vase: 'Vasos',
  'without-helmet': 'Equipamento de Segurança Incompleto',
  helmet: 'Equipamento de Segurança Incompleto',
  'scene change': 'Mudanças de Cenário',
  speed: 'Velocidade',
  jacket: 'Equipamento de Segurança Incompleto',
  'shopping-cart': 'Carrinho de Supermercado',
  hoodie: 'Capuz',
}

export function translateObjectName(name: string) {
  const keys = Object.keys(objectTranslated).map((key) => key.toLowerCase())
  const words = name.split(', ')

  const translatedWords = words.map((word) => {
    const lowerCaseWord = word.toLowerCase()
    if (keys.includes(lowerCaseWord)) {
      return capitalizeText(objectTranslated[lowerCaseWord] || word)
    }
    return capitalizeText(word)
  })

  return capitalizeText(translatedWords.join(', '))
}

export function capitalizeText(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const DEFAULT_COLORS = [
  '#468FAF',
  '#6D597A',
  '#B56576',
  '#4F759B',
  '#E76F51',
  '#2A9D8F',
  '#F4A261',
  '#8AB17D',
  '#D4A373',
  '#3D5A80',
  '#EE6C4D',
  '#A7C957',
  '#F28585',
  '#8E9AAF',
  '#DDA15E',
  '#94D2BD',
  '#E9C46A',
  '#5E6472',
  '#B5838D',
  '#FFB703',
  '#AC3B61',
  '#5A189A',
  '#E63946',
  '#9B5DE5',
  '#F28482',
  '#457B9D',
  '#E5989B',
]
